import { Dropdown, DropdownItem } from 'react-bootstrap'

interface DropdownSortProvidersProps {
  sortMethod: string
  onSelectSort: (method: string) => void
}

export const DropdownSortProviders: React.FC<DropdownSortProvidersProps> = ({ sortMethod, onSelectSort }) => {
  const sortOptions = [
    {
      label: 'Nombre A-Z',
      value: 'name-asc',
    },
    {
      label: 'Nombre Z-A',
      value: 'name-desc',
    },
    {
      label: ' Más nuevo',
      value: 'newest',
    },
    {
      label: 'Más antiguo',
      value: 'oldest',
    },
  ]
  const selectedOption = sortOptions.find((option) => option.value === sortMethod)
  const displayedLabel = selectedOption ? selectedOption.label : 'Ordenar por'
  return (
    <div className="">
      <div className="">
        <Dropdown>
          <Dropdown.Toggle variant="phoenix-primary">{displayedLabel}</Dropdown.Toggle>
          <Dropdown.Menu className="">
            {sortOptions.map((option, index) => (
              <DropdownItem key={index} onClick={() => onSelectSort(option.value)}>
                {option.label}
              </DropdownItem>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}
